export const aiAutomationPagesData = {
    "conversational-ai": {
        seo: {
            title: "Conversational AI Solutions & Chatbot Development | Mobikode",
            description:
                "Mobikode delivers conversational AI solutions, AI chatbot development, voice assistants, natural language understanding, and business system integrations to improve customer engagement and support.",
            keywords:
                "Conversational AI, Conversational AI Solutions, Conversational AI Development, AI Chatbot Development, Enterprise Chatbots, AI Voice Assistants, Natural Language Processing, Natural Language Understanding, Customer Service Automation, Omnichannel Conversational AI, AI Virtual Assistant, Conversational AI Integration, Business Chatbot Solutions",
            canonical: "https://www.mobikode.com/conversational-ai",
            ogTitle: "Conversational AI Solutions & Chatbot Development | Mobikode",
            ogDescription:
                "Improve customer engagement with Mobikode's conversational AI solutions, intelligent chatbots, voice assistants, and connected conversational workflows.",
            ogUrl: "https://www.mobikode.com/conversational-ai",
            ogType: "website",
            ogImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
            twitterCard: "summary_large_image",
            twitterTitle: "Conversational AI Solutions & Chatbot Development | Mobikode",
            twitterDescription:
                "Explore conversational AI solutions from Mobikode, including AI chatbots, voice assistants, natural language understanding, and business system integrations.",
            twitterImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
        },
        hero: {
            title: "Conversational AI",
            text: "Conversations. Intelligence. Connection.",
            imgData: "/assets/service-detail/bg3.png",
        },
        foundation: {
            badge: "Start with the right foundation",
            title: "Creating Better Conversations with AI",
            description:
                "At Mobikode, we help businesses create meaningful customer experiences with conversational AI. From intelligent chatbots to voice assistants, our solutions understand user intent, provide relevant responses, and connect conversations with business workflows. The result is more accessible support, smoother customer journeys, and more efficient operations.",
            imageSrc: "/assets/career/img9.jpg",
            imageAlt: "Conversational AI chatbot and virtual assistant solutions",
        },
        whyAiAutomation: {
            heading: "Why Conversational AI with Mobikode?",
            desc: "Create natural customer interactions with conversational AI that understands user intent, responds contextually, and helps people find the information they need.",
            approachData: [
                {
                    id: 1,
                    title: "Natural, Human-Like Conversations",
                    description:
                        "Create natural customer interactions with conversational AI that understands user intent, responds contextually, and helps people find the information they need.",
                    image: "/assets/career/img10.png",
                },
                {
                    id: 2,
                    title: "Always-On Customer Support",
                    description:
                        "Provide consistent support around the clock with AI assistants that answer common questions, guide users, and handle routine requests without long wait times.",
                    image: "/assets/home-/ai-2.png",
                },
                {
                    id: 3,
                    title: "Personalized Customer Experiences",
                    description:
                        "Deliver relevant responses and recommendations using conversation context and connected business information to make every interaction more useful.",
                    image: "/assets/home-/ai-3.png",
                },
                {
                    id: 4,
                    title: "Connected, Efficient Workflows",
                    description:
                        "Connect conversational AI with your business tools and workflows to reduce repetitive tasks, improve response times, and deliver better customer experiences.",
                    image: "/assets/home-/ai-4.png",
                },
            ],
        },
        techServices: {
            heading: "Our Conversational AI Services",
            services: [
                {
                    id: 1,
                    title: "AI Chatbot Development",
                    category: "service",
                    desc: "Build intelligent chatbots for websites and digital platforms that answer questions, guide users, qualify leads, and support customers through relevant, context-aware conversations.",
                    defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
                },
                {
                    id: 2,
                    title: "AI Voice Assistants",
                    category: "service",
                    desc: "Create voice-based AI assistants that manage enquiries, provide information, support customer interactions, and enable natural spoken conversations across business touchpoints.",
                    defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
                },
                {
                    id: 3,
                    title: "Natural Language Understanding",
                    category: "service",
                    desc: "Enable AI systems to understand user intent, identify important information, interpret different questions, and generate more relevant responses based on conversational context.",
                    defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
                },
                {
                    id: 4,
                    title: "Omnichannel Conversational AI",
                    category: "service",
                    desc: "Deliver consistent conversational experiences across websites, messaging platforms, and other customer touchpoints through a unified conversational AI solution.",
                    defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
                },
                {
                    id: 5,
                    title: "CRM & Business System Integration",
                    category: "service",
                    desc: "Connect conversational AI with CRM platforms, knowledge bases, and business applications to provide relevant information, streamline enquiries, and support faster resolutions.",
                    defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
                },
                {
                    id: 6,
                    title: "Conversational Workflow Automation",
                    category: "service",
                    desc: "Automate routine conversation-driven tasks such as lead qualification, appointment scheduling, enquiry routing, customer onboarding, and service request handling.",
                    defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
                },
                {
                    id: 7,
                    title: "Conversation Analytics & Optimization",
                    category: "service",
                    desc: "Analyze conversation patterns, identify common customer needs, measure interaction performance, and continuously improve responses and customer journeys.",
                    defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#141E30]",
                },
                {
                    id: 9,
                    title: "Custom Conversational AI Solutions",
                    category: "service",
                    desc: "Develop tailored conversational AI solutions aligned with your business goals, audience, workflows, customer support requirements, and existing technology ecosystem.",
                    defaultBg: "bg-gradient-to-br from-[#004e92] to-[#01386A]",
                },
            ],
        },
        industries: {
            heading: "Industries We Serve",
            steps: [
                {
                    id: 1,
                    step: "01",
                    title: "Banking & Financial Services",
                    description:
                        "We use AI to help banks stay safe, catch fraud early, and meet compliance easily, while also creating more personal and better customer experiences.",
                    image: "/assets/career/img11.png",
                },
                {
                    id: 2,
                    step: "02",
                    title: "Healthcare & Life Sciences",
                    description:
                        "We help speed up drug discovery and improve patient care by using smart data and automation to support faster, more informed healthcare decisions.",
                    image: "/assets/product/ai3.png",
                },
                {
                    id: 3,
                    step: "03",
                    title: "Retail & E-commerce",
                    description:
                        "We help make shopping easier and more enjoyable by using AI to suggest the right products, manage stock better, and create smooth experiences across all channels, so customers feel more connected and satisfied.",
                    image: "/assets/product/ai1.png",
                },
                {
                    id: 4,
                    step: "04",
                    title: "Manufacturing",
                    description:
                        "We use IoT and AI to make supply chains smarter and maintenance more proactive, so businesses face less downtime and operations run more smoothly and efficiently.",
                    image: "/assets/product/ai2.png",
                },
            ],
        },
        whyPartner: {
            heading: "Why Partner with Mobikode?",
            faqData: [
                {
                    id: 1,
                    title: "Proven Expertise in Enterprise AI Deployment",
                    desc: "Our seasoned engineers design, fine-tune, and roll out production-grade AI architectures with robust security, compliance, and zero downtime.",
                },
                {
                    id: 2,
                    title: "Agile & Scalable Solutions Built to Grow",
                    desc: "We develop modular data and AI pipelines that adapt seamlessly to expanding workloads, new integrations, and evolving business goals.",
                },
                {
                    id: 3,
                    title: "Enterprise Governance & Security by Design",
                    desc: "Built-in data lineage, role-based access controls, and strict compliance guardrails protect sensitive assets across the entire lifecycle.",
                },
                {
                    id: 4,
                    title: "Measurable ROI & Faster Time-to-Value",
                    desc: "We prioritize high-impact use cases first, delivering operational prototypes in weeks to drive immediate business value and efficiency.",
                },
            ],
        },
        banner: {
            title: "Conversational AI",
            text: "Create more helpful, connected, and responsive customer experiences with intelligent conversational AI solutions.",
        },
    },
    "machine-learning-mlops": {
        seo: {
            title: "Machine Learning & MLOps Services | Mobikode",
            description:
                "Mobikode provides machine learning and MLOps services, including custom ML model development, predictive analytics, automated ML pipelines, model deployment, monitoring, and scalable ML infrastructure.",
            keywords:
                "Machine Learning Services, MLOps Services, Machine Learning Development, MLOps Consulting, ML Model Deployment, Machine Learning Pipeline, ML Model Monitoring, Predictive Analytics, Automated Machine Learning, Model Training, Model Versioning, Data Drift Monitoring, ML Infrastructure, Cloud Machine Learning Solutions, Enterprise Machine Learning",
            canonical: "https://www.mobikode.com/machine-learning-mlops",
            ogTitle: "Machine Learning & MLOps Services | Mobikode",
            ogDescription:
                "Build, deploy, and manage production-ready machine learning solutions with Mobikode. Explore ML development, predictive analytics, MLOps automation, model monitoring, and scalable infrastructure.",
            ogUrl: "https://www.mobikode.com/machine-learning-mlops",
            ogType: "website",
            ogImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
            twitterCard: "summary_large_image",
            twitterTitle: "Machine Learning & MLOps Services | Mobikode",
            twitterDescription:
                "Discover Mobikode's machine learning and MLOps solutions for model development, automated pipelines, production deployment, performance monitoring, and continuous improvement.",
            twitterImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
        },
        hero: {
            title: "Machine Learning & MLOps",
            text: "Data. Intelligence. Innovation.",
            imgData: "/assets/service-detail/bg3.png",
        },
        foundation: {
            title: "Turning Machine Learning into Business Value",
            description:
                "At Mobikode, we help businesses transform data into intelligent, production-ready machine learning solutions. From developing custom ML models to automating model deployment and monitoring, our approach connects experimentation with real-world business operations. With scalable MLOps workflows, we help teams improve model reliability, simplify maintenance, and manage the machine learning lifecycle more efficiently.",
            imageSrc: "/assets/career/img9.jpg",
            imageAlt: "Machine learning model development and MLOps solutions",
        },
        whyAiAutomation: {
            heading: "Why Machine Learning & MLOps with Mobikode?",
            desc: "Turn business data into actionable insights using machine learning models that identify patterns, forecast trends, and support more informed decision-making.",
            features: [
                {
                    id: 1,
                    title: "Intelligent Predictive Insights",
                    description:
                        "Turn business data into actionable insights using machine learning models that identify patterns, forecast trends, and support more informed decision-making.",
                    image: "/assets/career/img10.png",
                },
                {
                    id: 2,
                    title: "Scalable Machine Learning Models",
                    description:
                        "Build and deploy machine learning models designed to handle growing data volumes, evolving business requirements, and changing operational demands.",
                    image: "/assets/home-/ai-2.png",
                },
                {
                    id: 3,
                    title: "Automated ML Workflows",
                    description:
                        "Streamline model development, testing, deployment, and monitoring with automated machine learning pipelines that improve consistency and reduce repetitive work.",
                    image: "/assets/home-/ai-3.png",
                },
                {
                    id: 4,
                    title: "Continuous Model Improvement",
                    description:
                        "Monitor model performance, detect data and model drift, and support continuous retraining to keep machine learning solutions reliable as business conditions change.",
                    image: "/assets/home-/ai-4.png",
                },
            ],
        },
        techServices: {
            heading: "Our Machine Learning & MLOps Services",
            services: [
                {
                    id: 1,
                    title: "Machine Learning Development",
                    category: "service",
                    desc: "Develop custom machine learning models that help businesses uncover patterns, automate predictions, improve operational efficiency, and solve complex business challenges.",
                    defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
                },
                {
                    id: 2,
                    title: "Predictive Analytics",
                    category: "service",
                    desc: "Use historical and real-time data to forecast demand, identify emerging trends, estimate business outcomes, and support proactive decision-making.",
                    defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
                },
                {
                    id: 3,
                    title: "MLOps Pipeline Development",
                    category: "service",
                    desc: "Build automated machine learning pipelines for data preparation, model training, testing, validation, and deployment to create repeatable ML workflows.",
                    defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
                },
                {
                    id: 4,
                    title: "Model Deployment & Serving",
                    category: "service",
                    desc: "Deploy machine learning models into production environments through scalable serving infrastructure, API integrations, and reliable release workflows.",
                    defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
                },
                {
                    id: 5,
                    title: "ML Model Monitoring",
                    category: "service",
                    desc: "Monitor model performance, prediction quality, data drift, and operational metrics to identify issues and maintain dependable machine learning systems.",
                    defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
                },
                {
                    id: 6,
                    title: "Data Engineering for ML",
                    category: "service",
                    desc: "Build dependable data pipelines that collect, transform, validate, and deliver quality data for machine learning development, training, and inference.",
                    defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
                },
                {
                    id: 7,
                    title: "Model Optimization & Retraining",
                    category: "service",
                    desc: "Improve model performance through evaluation, hyperparameter tuning, version management, and retraining workflows aligned with changing data and business requirements.",
                    defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#141E30]",
                },
                {
                    id: 9,
                    title: "Cloud-Based ML Infrastructure",
                    category: "service",
                    desc: "Design scalable cloud infrastructure for machine learning workloads, including model training, experiment tracking, deployment, resource management, and production operations.",
                    defaultBg: "bg-gradient-to-br from-[#004e92] to-[#01386A]",
                },
            ],
        },
        industries: {
            heading: "Industries We Serve",
            items: [
                {
                    id: 1,
                    step: "01",
                    title: "Banking & Financial Services",
                    description:
                        "We use AI to help banks stay safe, catch fraud early, and meet compliance easily, while also creating more personal and better customer experiences.",
                    image: "/assets/career/img11.png",
                },
                {
                    id: 2,
                    step: "02",
                    title: "Healthcare & Life Sciences",
                    description:
                        "We help speed up drug discovery and improve patient care by using smart data and automation to support faster, more informed healthcare decisions.",
                    image: "/assets/product/ai3.png",
                },
                {
                    id: 3,
                    step: "03",
                    title: "Retail & E-commerce",
                    description:
                        "We help make shopping easier and more enjoyable by using AI to suggest the right products, manage stock better, and create smooth experiences across all channels, so customers feel more connected and satisfied.",
                    image: "/assets/product/ai1.png",
                },
                {
                    id: 4,
                    step: "04",
                    title: "Manufacturing",
                    description:
                        "We use IoT and AI to make supply chains smarter and maintenance more proactive, so businesses face less downtime and operations run more smoothly and efficiently.",
                    image: "/assets/product/ai2.png",
                },
            ],
        },
        whyPartner: {
            heading: "Why Partner with Mobikode?",
            faqData: [
                {
                    id: 1,
                    title: "Proven Expertise in Enterprise AI Deployment",
                    desc: "Our seasoned engineers design, fine-tune, and roll out production-grade AI architectures with robust security, compliance, and zero downtime.",
                },
                {
                    id: 2,
                    title: "Agile & Scalable Solutions Built to Grow",
                    desc: "We develop modular data and AI pipelines that adapt seamlessly to expanding workloads, new integrations, and evolving business goals.",
                },
                {
                    id: 3,
                    title: "Enterprise Governance & Security by Design",
                    desc: "Built-in data lineage, role-based access controls, and strict compliance guardrails protect sensitive assets across the entire lifecycle.",
                },
                {
                    id: 4,
                    title: "Measurable ROI & Faster Time-to-Value",
                    desc: "We prioritize high-impact use cases first, delivering operational prototypes in weeks to drive immediate business value and efficiency.",
                },
            ],
        },
        banner: {
            title: "Machine Learning & MLOps",
            text: "Build smarter, scalable, and production-ready machine learning solutions that turn data into measurable business outcomes.",
        },
    },
    "generative-ai-llm": {
        seo: {
            title: "Generative AI & LLM Development Services | Mobikode",
            description:
                "Mobikode delivers Generative AI and LLM development services, including large language model integration, RAG solutions, AI copilots, AI agents, prompt engineering, and enterprise AI applications.",
            keywords:
                "Generative AI Services, Generative AI Development, Large Language Models, LLM Development Services, LLM Integration, Enterprise Generative AI, Retrieval Augmented Generation, RAG Development, AI Copilot Development, AI Agents, LLM Fine Tuning, Prompt Engineering, AI Application Development, LLM Optimization, Enterprise AI Solutions",
            canonical: "https://www.mobikode.com/generative-ai-llm",
            ogTitle: "Generative AI & LLM Development Services | Mobikode",
            ogDescription:
                "Build business-ready generative AI applications with Mobikode. Explore LLM integration, RAG, AI copilots, AI agents, prompt engineering, and enterprise AI solutions.",
            ogUrl: "https://www.mobikode.com/generative-ai-llm",
            ogType: "website",
            ogImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
            twitterCard: "summary_large_image",
            twitterTitle: "Generative AI & LLM Development Services | Mobikode",
            twitterDescription:
                "Discover Mobikode's Generative AI and LLM services, including RAG applications, AI copilots, AI agents, model integration, and enterprise AI development.",
            twitterImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
        },
        hero: {
            title: "Generative AI & LLM",
            text: "Intelligence. Creativity. Transformation.",
            imgData: "/assets/service-detail/bg3.png",
        },
        foundation: {
            title: "Transforming Business with Generative AI",
            description:
                "At Mobikode, we help businesses unlock the potential of Generative AI and large language models. From intelligent assistants and AI-powered knowledge systems to custom LLM applications and workflow automation, we develop solutions aligned with real business needs. Our approach combines model integration, contextual data retrieval, and responsible implementation to help organizations improve productivity, access information faster, and build more intelligent digital experiences.",
            imageSrc: "/assets/career/img9.jpg",
            imageAlt: "Generative AI and large language model development solutions",
        },
        whyAiAutomation: {
            heading: "Why Generative AI & LLM with Mobikode?",
            desc: "Build AI applications that understand prompts, interpret context, and generate useful responses grounded in your business information and requirements.",
            features: [
                {
                    id: 1,
                    title: "Intelligent Content Generation",
                    description:
                        "Generate relevant text, summaries, reports, and other content with generative AI solutions tailored to your business workflows and communication needs.",
                    image: "/assets/career/img10.png",
                },
                {
                    id: 2,
                    title: "Context-Aware AI Experiences",
                    description:
                        "Build AI applications that understand prompts, interpret context, and generate useful responses grounded in your business information and requirements.",
                    image: "/assets/home-/ai-2.png",
                },
                {
                    id: 3,
                    title: "Enterprise Knowledge Access",
                    description:
                        "Make business knowledge easier to access through AI-powered search, document understanding, and retrieval-augmented generation solutions.",
                    image: "/assets/home-/ai-3.png",
                },
                {
                    id: 4,
                    title: "Scalable AI Integration",
                    description:
                        "Integrate large language models into existing applications and workflows with appropriate security controls, performance optimization, and scalable infrastructure.",
                    image: "/assets/home-/ai-4.png",
                },
            ],
        },
        techServices: {
            heading: "Our Generative AI & LLM Services",
            services: [
                {
                    id: 1,
                    title: "Generative AI Development",
                    category: "service",
                    desc: "Develop custom generative AI applications that create content, assist users, process information, and support business-specific use cases using modern AI models.",
                    defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
                },
                {
                    id: 2,
                    title: "Large Language Model Integration",
                    category: "service",
                    desc: "Integrate large language models into business applications to support intelligent text generation, question answering, summarization, and natural language interactions.",
                    defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
                },
                {
                    id: 3,
                    title: "Retrieval-Augmented Generation (RAG)",
                    category: "service",
                    desc: "Build RAG solutions that connect language models with your documents, knowledge bases, and business data to deliver more relevant, context-grounded responses.",
                    defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
                },
                {
                    id: 4,
                    title: "Custom LLM Development & Fine-Tuning",
                    category: "service",
                    desc: "Adapt suitable language models to domain-specific requirements through fine-tuning, prompt optimization, and evaluation based on your business use cases.",
                    defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
                },
                {
                    id: 5,
                    title: "AI Copilots & Virtual Assistants",
                    category: "service",
                    desc: "Create AI-powered assistants that help employees and customers find information, summarize content, complete tasks, and interact with business systems.",
                    defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
                },
                {
                    id: 6,
                    title: "AI Agents & Workflow Automation",
                    category: "service",
                    desc: "Develop AI agents that use approved tools and business integrations to support multi-step workflows, retrieve information, and assist with routine operational tasks.",
                    defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
                },
                {
                    id: 7,
                    title: "Prompt Engineering & Optimization",
                    category: "service",
                    desc: "Design and refine prompts, system instructions, and context strategies to improve response quality, consistency, relevance, and model performance.",
                    defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#141E30]",
                },
                {
                    id: 9,
                    title: "LLM Evaluation & Optimization",
                    category: "service",
                    desc: "Evaluate AI outputs for quality, relevance, reliability, latency, and cost. Optimize model selection and application workflows to meet production requirements.",
                    defaultBg: "bg-gradient-to-br from-[#004e92] to-[#01386A]",
                },
            ],
        },
        industries: {
            heading: "Industries We Serve",
            items: [
                {
                    id: 1,
                    step: "01",
                    title: "Banking & Financial Services",
                    description:
                        "We use AI to help banks stay safe, catch fraud early, and meet compliance easily, while also creating more personal and better customer experiences.",
                    image: "/assets/career/img11.png",
                },
                {
                    id: 2,
                    step: "02",
                    title: "Healthcare & Life Sciences",
                    description:
                        "We help speed up drug discovery and improve patient care by using smart data and automation to support faster, more informed healthcare decisions.",
                    image: "/assets/product/ai3.png",
                },
                {
                    id: 3,
                    step: "03",
                    title: "Retail & E-commerce",
                    description:
                        "We help make shopping easier and more enjoyable by using AI to suggest the right products, manage stock better, and create smooth experiences across all channels, so customers feel more connected and satisfied.",
                    image: "/assets/product/ai1.png",
                },
                {
                    id: 4,
                    step: "04",
                    title: "Manufacturing",
                    description:
                        "We use IoT and AI to make supply chains smarter and maintenance more proactive, so businesses face less downtime and operations run more smoothly and efficiently.",
                    image: "/assets/product/ai2.png",
                },
            ],
        },
        whyPartner: {
            heading: "Why Partner with Mobikode?",
            faqData: [
                {
                    id: 1,
                    title: "Proven Expertise in Enterprise AI Deployment",
                    desc: "Our seasoned engineers design, fine-tune, and roll out production-grade AI architectures with robust security, compliance, and zero downtime.",
                },
                {
                    id: 2,
                    title: "Agile & Scalable Solutions Built to Grow",
                    desc: "We develop modular data and AI pipelines that adapt seamlessly to expanding workloads, new integrations, and evolving business goals.",
                },
                {
                    id: 3,
                    title: "Enterprise Governance & Security by Design",
                    desc: "Built-in data lineage, role-based access controls, and strict compliance guardrails protect sensitive assets across the entire lifecycle.",
                },
                {
                    id: 4,
                    title: "Measurable ROI & Faster Time-to-Value",
                    desc: "We prioritize high-impact use cases first, delivering operational prototypes in weeks to drive immediate business value and efficiency.",
                },
            ],
        },
        banner: {
            title: "Generative AI & LLM",
            text: "Build intelligent AI-powered applications that unlock knowledge, accelerate workflows, and create new possibilities for your business.",
        },
    },
    "ai-automation": {
        seo: {
            title:
                "AI & Automation Services | Intelligent Business Automation | Mobikode",
            description:
                "Mobikode delivers AI and intelligent automation services that help enterprises streamline operations, improve customer experiences, automate workflows, optimize costs, and drive sustainable business growth.",
            keywords:
                "AI Automation Services, AI & Automation Solutions, Intelligent Automation Services, AI Automation Company, Enterprise AI Solutions, AI Workflow Automation, Business Process Automation, Intelligent Business Automation, AI Consulting Services, AI Powered Automation, Enterprise Automation Solutions, AI Enterprise AI & ServiceNow Consulting Company, Industrial Automation Solutions, Automation Consulting Services",
            canonical: "https://www.mobikode.com/ai-automation",
            ogTitle:
                "AI & Automation Services | Intelligent Business Automation | Mobikode",
            ogDescription:
                "Transform business operations with Mobikode's AI and intelligent automation solutions. Build smarter workflows, enhance customer engagement, improve decision-making, and create scalable digital operations.",
            ogUrl: "https://www.mobikode.com/ai-automation",
            ogType: "website",
            ogImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
            twitterCard: "summary_large_image",
            twitterTitle:
                "AI & Automation Services | Intelligent Business Automation | Mobikode",
            twitterDescription:
                "Explore Mobikode's AI and automation solutions for intelligent workflows, customer engagement, enterprise operations, cloud, product engineering, ServiceNow, ERP, and industrial automation.",
            twitterImage: "https://www.mobikode.com/assets/service-detail/bg3.png",
        },
        hero: {
            title: "AI & Automation",
            text: "Technology. Transformation. Trust.",
            imgData: "/assets/service-detail/bg3.png",
        },
        foundation: {
            title: "Empowering Enterprises with Intelligent Automation",
            description:
                "At Mobikode, we help forward-thinking businesses make the most of AI and intelligent automation. Our goal is simple to create smart, secure, and scalable solutions that make work easier, improve how you connect with customers, and support steady, long-term growth as your business evolves.",
            imageSrc: "/assets/career/img9.jpg",
            imageAlt: "ai automation",
        },
        whyAiAutomation: {
            heading: "Why AI & Automation with Mobikode?",
            desc: "Shift from manual, repetitive tasks to AI-driven autonomy. We help build resilient systems that adapt to market changes instantly.",
            features: [
                {
                    id: 1,
                    title: "Future-Ready Enterprises",
                    description:
                        "Shift from manual, repetitive tasks to AI-driven autonomy. We help build resilient systems that adapt to market changes instantly.",
                    image: "/assets/career/img10.png",
                },
                {
                    id: 2,
                    title: "Smarter Decision-Making",
                    description:
                        "Leverage advanced analytics and machine learning models to process vast amounts of data, turning noise into actionable business insights.",
                    image: "/assets/home-/ai-2.png",
                },
                {
                    id: 3,
                    title: "Customer-First Engagement",
                    description:
                        "Personalize every touchpoint with AI-powered recommendations and chatbots that understand intent, ensuring a seamless customer journey.",
                    image: "/assets/home-/ai-3.png",
                },
                {
                    id: 4,
                    title: "End-to-End Value",
                    description:
                        "From strategy to execution, we ensure that automation is not just a tool but a value driver that optimizes costs and maximizes efficiency.",
                    image: "/assets/home-/ai-4.png",
                },
            ],
        },
        techServices: {
            heading: "Our Service Offerings",
            services: [
                {
                    id: 1,
                    title: "AI & Automation",
                    category: "service",
                    desc: "Helping businesses work smarter with AI and automation, making everyday tasks easier, reducing costs, and supporting steady, meaningful growth.",
                    defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
                },
                {
                    id: 2,
                    title: "Cloud Engineering",
                    category: "service",
                    desc: "We build secure cloud systems that fit your business and grow with you smoothly.",
                    defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
                },
                {
                    id: 3,
                    title: "Product Engineering",
                    category: "service",
                    desc: "We help turn ideas into real products designing, building, and scaling them so they can grow confidently and succeed in global markets.",
                    defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
                },
                {
                    id: 4,
                    title: "Performance Engineering",
                    category: "service",
                    desc: "Improve systems for better speed, stability, efficiency, and reliability.",
                    defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
                },
                {
                    id: 5,
                    title: "ServiceNow Consulting",
                    category: "service",
                    desc: "We help simplify your business processes with expert ServiceNow implementation and guidance.",
                    defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
                },
                {
                    id: 6,
                    title: "Infor M3 Solutions",
                    category: "service",
                    desc: "Helping enterprises streamline operations with tailored Infor M3 ERP solutions and dedicated support.",
                    defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
                },
                {
                    id: 7,
                    title: "MES Solutions",
                    category: "service",
                    desc: "We evaluate MES readiness, understand current maturity, and build practical roadmaps with clear business value.",
                    defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#141E30]",
                },
                {
                    id: 9,
                    title: "Industrial Automation Solutions",
                    category: "service",
                    desc: "We help industries run smarter with complete automation solutions, from field devices to PLC, DCS, SCADA, and data systems. Our focus is simple: make operations more reliable, efficient, and easy to manage every day.",
                    defaultBg: "bg-gradient-to-br from-[#004e92] to-[#01386A]",
                },
            ],
        },
        industries: {
            heading: "Industries We Serve",
            items: [
                {
                    id: 1,
                    step: "01",
                    title: "Banking & Financial Services",
                    description:
                        "We use AI to help banks stay safe, catch fraud early, and meet compliance easily, while also creating more personal and better customer experiences.",
                    image: "/assets/career/img11.png",
                },
                {
                    id: 2,
                    step: "02",
                    title: "Healthcare & Life Sciences",
                    description:
                        "We help speed up drug discovery and improve patient care by using smart data and automation to support faster, more informed healthcare decisions.",
                    image: "/assets/product/ai3.png",
                },
                {
                    id: 3,
                    step: "03",
                    title: "Retail & E-commerce",
                    description:
                        "We help make shopping easier and more enjoyable by using AI to suggest the right products, manage stock better, and create smooth experiences across all channels, so customers feel more connected and satisfied.",
                    image: "/assets/product/ai1.png",
                },
                {
                    id: 4,
                    step: "04",
                    title: "Manufacturing",
                    description:
                        "We use IoT and AI to make supply chains smarter and maintenance more proactive, so businesses face less downtime and operations run more smoothly and efficiently.",
                    image: "/assets/product/ai2.png",
                },
            ],
        },
        whyPartner: {
            heading: "Why Partner with Mobikode?",
            faqData: [
                {
                    id: 1,
                    title: "Proven Expertise in Enterprise AI Deployment",
                    desc: "Our seasoned engineers design, fine-tune, and roll out production-grade AI architectures with robust security, compliance, and zero downtime.",
                },
                {
                    id: 2,
                    title: "Agile & Scalable Solutions Built to Grow",
                    desc: "We develop modular data and AI pipelines that adapt seamlessly to expanding workloads, new integrations, and evolving business goals.",
                },
                {
                    id: 3,
                    title: "Enterprise Governance & Security by Design",
                    desc: "Built-in data lineage, role-based access controls, and strict compliance guardrails protect sensitive assets across the entire lifecycle.",
                },
                {
                    id: 4,
                    title: "Measurable ROI & Faster Time-to-Value",
                    desc: "We prioritize high-impact use cases first, delivering operational prototypes in weeks to drive immediate business value and efficiency.",
                },
            ],
        },
        banner: {
            title: "AI & Automation",
            text: "Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation.",
        },
    },
    "agentic-ai-services": {
        seo: {
            title:
                "Agentic AI Services for Enterprises | AI Agents & Automation | Mobikode",
            description:
                "Mobikode delivers Agentic AI services for enterprises, building autonomous AI agents that automate complex workflows, improve decision-making, enhance customer experiences, and drive operational efficiency.",
            keywords:
                "Agentic AI Services, Agentic AI Solutions, Enterprise AI Agents, AI Agent Development, AI Automation Services, Autonomous AI Agents, Custom AI Agents, Enterprise AI Automation, AI Workflow Automation, AI Customer Experience Agents, AI Agents for IT Operations, Knowledge AI Agents, Decision Intelligence AI, Custom Enterprise AI Solutions",
            canonical: "https://www.mobikode.com/agentic-ai-services",
            ogTitle:
                "Agentic AI Services for Enterprises | AI Agents & Automation | Mobikode",
            ogDescription:
                "Build smarter and more autonomous business operations with Mobikode's Agentic AI solutions. Deploy intelligent AI agents for enterprise automation, customer experience, IT operations, decision support, and custom business workflows.",
            ogUrl: "https://www.mobikode.com/agentic-ai-services",
            ogType: "website",
            ogImage: "https://www.mobikode.com/assets/product/bg3.png",
            twitterCard: "summary_large_image",
            twitterTitle: "Agentic AI Services for Enterprises | Mobikode",
            twitterDescription:
                "Explore Mobikode's Agentic AI services for enterprise automation, customer experience, IT operations, knowledge management, decision support, and custom AI agent development.",
            twitterImage: "https://www.mobikode.com/assets/product/bg3.png",
        },
        hero: {
            title: "Agentic AI Services for Enterprises",
            text: "At Mobikode, we build autonomous AI agents that take care of complex work behind the scenes. They help simplify everyday workflows, support better decision-making, and improve overall efficiency as your business grows.",
            imgData: "/assets/product/bg3.png",
        },
        foundation: {
            title:
                "Unlock Enterprise-Scale Efficiency, Innovation, and Growth with Agentic AI",
            description:
                "At Mobikode, we help businesses use Agentic AI to work smarter and grow faster. These intelligent systems don’t just follow instructions they understand, decide, and take action. We focus on building practical solutions that improve efficiency, spark innovation, and support real business outcomes.",
            imageSrc: "/assets/product/img3.png",
            imageAlt: "ai automation",
        },
        industries: {
            heading: "Our Agentic AI Service Offerings",
            items: [
                {
                    id: 1,
                    title: "AI-Powered Enterprise Automation",
                    description:
                        "Make your workflows smoother with AI agents that handle approvals, reporting, vendor tasks, and employee queries quickly, accurately, and effortlessly.",
                    image: "/assets/product/agentic1.png",
                },
                {
                    id: 2,
                    title: "Customer Experience Agents",
                    description:
                        "Deploy AI-powered virtual agents that naturally engage with customers, understand their needs, and resolve issues early creating smoother, faster, and more helpful experiences.",
                    image: "/assets/product/agentic2.png",
                },
                {
                    id: 3,
                    title: "AI Agents for IT & Operations",
                    description:
                        "Stay ahead with AI that helps you monitor systems, fix issues early, and prevent downtime.",
                    image: "/assets/product/agentic3.png",
                },
                {
                    id: 4,
                    title: "Knowledge & Decision Agents",
                    description:
                        "Help your teams and leaders make faster, confident decisions with AI that turns complex data into simple, clear insights in minutes.",
                    image: "/assets/product/agentic4.png",
                },
                {
                    id: 5,
                    title: "Custom Enterprise AI Agents",
                    description:
                        "Create custom AI agents designed around your business from finance tasks to supply chains built to simplify work and deliver real results.",
                    image: "/assets/product/agentic5.png",
                },
            ],
        },
        whyAiAutomation: {
            heading: "Why Choose Us?",
            
            features: [
                {
                    id: 1,
                    step: "01",
                    title: "Enterprise-Grade Expertise",
                    description: "We have hands-on experience delivering AI solutions that truly scale.",
                    bgImage: "/assets/career/wrap1.svg",
                },
                {
                    id: 2,
                    step: "02",
                    title: "Security & Compliance First",
                    description: "We keep your data safe and aligned with global standards.",
                    bgImage: "/assets/career/wrap1.svg",
                },
                {
                    id: 3,
                    step: "03",
                    title: "Customizable & Scalable",
                    description: "AI agents that grow with your business, every step forward.",
                    bgImage: "/assets/career/wrap1.svg",
                },
                {
                    id: 4,
                    step: "04",
                    title: "End-to-End Partnership",
                    description: "We help you adopt AI smoothly, from planning to execution.",
                    bgImage: "/assets/career/wrap1.svg",
                },
            ],
        },
        whyPartner: {
            heading: "Value Proposition",
            faqData: [
                {
                    id: 1,
                    title: "Autonomous Efficiency",
                    desc: "AI agents that handle routine tasks, saving time and effort.",
                },
                {
                    id: 2,
                    title: "Proactive Intelligence",
                    desc: "Stay ahead by spotting issues early, acting quickly, and making smarter, data-driven decisions.",
                },
                {
                    id: 3,
                    title: "Enterprise-Grade Security",
                    desc: "Built to grow with you, stay compliant, and support global ambitions.",
                },
                {
                    id: 4,
                    title: "Custom AI Agents",
                    desc: "Solutions thoughtfully built for HR, finance, IT, operations, and beyond.",
                },
            ],
        },
        banner: {
            title: "Agentic AI Services for Enterprises",
            text: "Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation.",
        },
    },
    
};